import { render, staticRenderFns } from "./CustomerStartFromExcelImport.vue?vue&type=template&id=135102f4&scoped=true&lang=pug&"
import script from "./CustomerStartFromExcelImport.vue?vue&type=script&lang=js&"
export * from "./CustomerStartFromExcelImport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStartFromExcelImport.vue?vue&type=style&index=0&id=135102f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135102f4",
  null
  
)

export default component.exports